import { useMutation, useQueryClient } from "@tanstack/react-query";
import { stergeTargetarePersoana } from "@/api/endpoints/targetareContacte";
import { queryKeys } from "@/lib/queryClient";

export function useStergeTargetarePersoana() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: stergeTargetarePersoana,
    onSuccess: (_, variabile) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.targetare.firma(variabile.cui),
      });
    },
  });
}
